import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function ReelsVideoIcon({ className, width = 24, height = 24 }: IconProps) {
    return (
        <svg
            className={cn('text-gray-700', className)}
            width={width}
            height={height}
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.5484 20.1599C13.2884 20.2699 13.0084 20.3699 12.7084 20.4699L11.1284 20.9899C7.15839 22.2699 5.06839 21.1999 3.77839 17.2299L2.49839 13.2799C1.21839 9.30992 2.27839 7.20992 6.24839 5.92992L7.78839 5.41992C7.59839 5.89992 7.43839 6.44992 7.28839 7.06992L6.30839 11.2599C5.20839 15.9699 6.81839 18.5699 11.5284 19.6899L13.2084 20.0899C13.3184 20.1199 13.4384 20.1399 13.5484 20.1599Z'
                fill='currentColor'
            />
            <path
                d='M17.1702 3.21001L15.5002 2.82001C12.1602 2.03001 10.1702 2.68001 9.00018 5.10001C8.70018 5.71001 8.46018 6.45001 8.26018 7.30001L7.28018 11.49C6.30018 15.67 7.59018 17.73 11.7602 18.72L13.4402 19.12C14.0202 19.26 14.5602 19.35 15.0602 19.39C18.1802 19.69 19.8402 18.23 20.6802 14.62L21.6602 10.44C22.6402 6.26001 21.3602 4.19001 17.1702 3.21001Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default ReelsVideoIcon;

